export enum ApiRoute {
  MERCHANT_INFO = "/billing-core/v1/merchant/merchantInfo",
}
